module.exports = {
  isClient: typeof window !== "undefined",
};
